export default __webpack_public_path__ + "locales/cs/HotkeysPanel.json?hash=977282f01171b86e1bf739aa97b90f65";